module.exports = __webpack_public_path__ + "img/IMG_9674-1.f034fa0c.png";